import { NavLink as NavLinkMantine } from '@mantine/core'
import styled from 'styled-components'

// Styled components baseados no NavLink do Mantine
const BaseNavLinkInfo = styled(NavLinkMantine)`
  transition: all 0.2s ease;
  color: #000;

  &:hover {
    background-color: #21875e !important;
  }
`

export const NavLinkInfoPrimeiro = styled(BaseNavLinkInfo)`
  height: 50px;
  padding-left: 16px;

  .mantine-NavLink-body {
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  }

  .mantine-Text-root,
  .mantine-NavLink-label {
    font-weight: 500;
    line-height: 50px;
    font-size: 16px;
    font-family: 'RobotoMedium', sans-serif;
    white-space: nowrap;
  }

  &:hover {
    background-color: #21875e !important;
  }
`

export const NavLinkInfo = styled(BaseNavLinkInfo)`
  height: 50px;
  padding-left: 16px;

  .mantine-NavLink-body {
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  }

  .mantine-Text-root,
  .mantine-NavLink-label {
    font-weight: 400;
    line-height: 50px;
    font-size: 16px;
    font-family: 'RobotoMedium', sans-serif;
    white-space: nowrap;
  }

  &:hover {
    background-color: #21875e !important;
  }
`

export const NavLinkInfoUltimo = styled(BaseNavLinkInfo)`
  height: 50px;
  padding-left: 16px;

  .mantine-Text-root,
  .mantine-NavLink-label {
    font-weight: 400;
    line-height: 50px;
    font-size: 16px;
    font-family: 'RobotoMedium', sans-serif;
    white-space: nowrap;
  }

  &:hover {
    background-color: #21875e !important;
  }
`

export const IconeSeta = styled.img`
  margin-top: -5px;
  margin-left: ${({ revelarInfosUsuario }) => !revelarInfosUsuario && '-5px'};
  width: 14px;
  height: 14px;
  transition: transform 0.3s ease;
  transform: ${({ revelarInfosUsuario }) =>
    revelarInfosUsuario ? 'rotateZ(360deg)' : 'rotateZ(270deg)'};
`
